<div
  class="bg-m0 flex h-full w-full min-w-[2px] select-none flex-col rounded shadow"
>
  <div
    class="text-r1 mb-6 ml-7 mr-6 mt-6 flex h-11 flex-shrink-0 flex-row items-center space-x-3 text-2xl font-semibold"
  >
    <m-exclamation-icon></m-exclamation-icon>
    <div>Merge Conflicts</div>
    <div class="flex flex-1"></div>
    <div
      *ngIf="isProduction === false"
      tp="FileEditor role is required to validate files"
      [tpIsEnabled]="isEditor === false"
    >
      <button
        type="button"
        data-cy="conflictsValidateButton"
        class="h-11 flex-shrink-0 select-none rounded border px-5 py-2 text-base font-medium focus:outline-none"
        [ngClass]="{
          'border-s400 text-s500 hover:bg-gray-50':
            isEditor === true && needSave === false,
          'border-s300 text-s400 cursor-default':
            isEditor === false || needSave === true
        }"
        (click)="validateClick.emit()"
        [disabled]="isEditor === false || needSave === true"
        >Validate Files</button
      >
    </div>
  </div>

  <div class="divide-s300 ml-6 mr-6 flex flex-col divide-y">
    <div class="flex flex-row"></div>
    <div class="flex flex-row"></div>
  </div>

  <div class="flex flex-grow flex-col overflow-y-auto">
    <div class="mt-2"></div>
    <div *ngIf="repo?.conflicts" class="h-2">
      <div
        *ngFor="let conflict of repo.conflicts"
        class="hover:bg-m50 px-6 py-2 text-base hover:cursor-pointer"
        (click)="goToFileLine(conflict)"
      >
        <div *ngIf="conflict.lineNumber !== 0" class="flex w-full flex-row">
          <div class="max-w-[80%] truncate">{{ conflict.fileName }}</div>

          <div class="ml-5 flex font-semibold"
            >line: {{ conflict.lineNumber }}</div
          >
        </div>

        <div class="font-semibold" *ngIf="conflict.lineNumber === 0"
          >line: {{ conflict.fileName }}</div
        >

        <!-- <div *ngIf="conflict.lineNumber !== 0" class="flex flex-row w-full">
          <div class="truncate max-w-[90%]">{{ conflict.fileName }}</div>

          <div class="flex ml-5"> - {{ conflict.lineNumber }}</div>
        </div>

        <div *ngIf="conflict.lineNumber === 0">{{ conflict.fileName }}</div> -->
      </div>
    </div>
  </div>
</div>

<div *ngIf="repo$ | async"></div>
